import { Tooltip as ReactTooltip } from "react-tooltip";
import { helpInfo } from "helper/icons";
import { globalVariables } from "helper/globalVariables";
import "tailwindcss/tailwind.css";

const TooltipComponent = () => {
  return (
    <div className="mt-1">
      <button className="ml-1.5" data-tooltip-id="my-tooltip">
        <img src={helpInfo} alt="" />
      </button>

      <ReactTooltip
        content={globalVariables.tooltipMsg}
        id="my-tooltip"
        className="bg-white rounded-lg shadow-md font-semibold text-gray-700 text-xs"
        place="right"
        effect="solid"
        variant="light"
      />
    </div>
  );
};

export default TooltipComponent;
